import ApiService from "../api.service";
const ProductCategoryService ={
    GetAll(lang){
        return ApiService.get(`/ProductCategory/GetAll?lang=${lang}`)
    },
    GetList(Search,SortColumn,OrderType,PageNumber,PageLimit){
        return ApiService.get(`/ProductCategory/GetList?Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}`)
    },
    Get(id){
        return ApiService.get(`/ProductCategory/Get?id=${id}`)
    },
    Update(data){
        return ApiService.post(`/ProductCategory/Update`,data)
    },
    Delete(id){
        return ApiService.delete(`/ProductCategory/Delete?id=${id}`)
    }
}
export default ProductCategoryService